import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { Link } from 'foundations-components/transitional/components/Link';
import AbstractRouterLink from 'ui-addon-react-router-dom/internal/AbstractRouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
const UniversalLink = _ref => {
  let otherProps = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  if (otherProps.to) {
    return /*#__PURE__*/_jsx(AbstractRouterLink, Object.assign({
      component: Link
    }, otherProps));
  }
  return /*#__PURE__*/_jsx(Link, Object.assign({}, otherProps));
};
export default UniversalLink;